import { certificatePropsApi } from "./query/certificateProps";

export const combinedMiddleware = [certificatePropsApi.middleware];
